import { LoginForm } from "@/components/auth/LoginForm";
import { Logo } from "@/components/icons";
import { MobileAppBadges } from "@/components/MobileAppBadges";
import { Link, useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import { ChevronLeft } from "lucide-react";

const safeRedirect = (value: string | null | undefined): string | undefined => {
  if (!value) {
    return undefined;
  }

  if (!value.startsWith("/")) {
    return undefined;
  }

  if (value.startsWith("//")) {
    return undefined;
  }

  return value;
};

export default function LoginPage() {
  const [searchParams] = useSearchParams();
  const redirectParam = useMemo(() => {
    const redirect = searchParams.get("redirect");
    return safeRedirect(redirect || undefined);
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-white p-6">
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center text-center">
          <Link to="/" className="mb-4">
            <Logo className="h-20 w-20 text-primary" />
          </Link>
          <h1 className="font-headline text-3xl font-bold text-foreground">Welcome Back!</h1>
          <p className="text-muted-foreground">Sign in to access your recipe boxes.</p>
        </div>
        <LoginForm redirectTo={redirectParam} />
        <p className="text-center text-sm text-muted-foreground">
          Don&apos;t have an account?{" "}
          <Link
            to="/signup"
            className="font-semibold text-primary underline-offset-4 hover:underline"
          >
            Sign up
          </Link>
        </p>
        <p className="text-center text-sm">
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
          >
            <ChevronLeft className="h-4 w-4" />
            Back to Home
          </Link>
        </p>
        <MobileAppBadges className="items-center pt-4" />
        <p className="text-center text-xs text-muted-foreground pt-2">
          <Link to="/privacy" className="hover:underline underline-offset-4">Privacy Policy</Link>
          {" · "}
          <Link to="/terms" className="hover:underline underline-offset-4">Terms of Service</Link>
        </p>
      </div>
    </div>
  );
}

